<template>
  <shared-product-provide :product="product" :fromModule="fromModule" :toModule="toModule">
    <loader :loading="loadingCategories || loadingAttributes"/>

    <form-group :label="$t('warranty.label')" :columns="3" :required="true" :error="getError('warranty', product.productId)">
      <input class="form-input" type="text" v-model="product.warranty" :disabled="disabledInputs()">
    </form-group>

    <form-group :label="$t('category.label')" :columns="12" :error="getError('category', product.productId)" :required="true">
      <multiselect
        v-model="category"
        :options="categories"
        selectLabel=""
        selectedLabel=""
        placeholder="Escolha"
        label="label"
        track-by="code"
      />
    </form-group>

    <form-group v-if="!loadingAttributes" :label="attribute.label" v-for="attribute in attributes" :key="attribute" :columns="3">
      <select class="form-select" v-model="attribute.value" v-if="attribute.typeSelection === 'select'">
        <option :value=null>{{ $t('choose.label') }}</option>
        <option v-for="attributeOption in attribute.options" :key="attributeOption" :value="attributeOption">{{ attributeOption }}</option>
      </select>

      <multiselect v-model="attribute.value" :options="attribute.options" :multiple="true" v-else-if="attribute.typeSelection === 'multipleSelect'" selectLabel="Clique" selectedLabel="Selecionado" placeholder="Selecione a opção"></multiselect>

      <input class="form-input" type="text" v-model="attribute.value" v-else>
    </form-group>
  </shared-product-provide>
</template>

<script>
  import api from '@/api'
  import { isArray, isEmpty } from 'lodash'
  import { mapActions, mapGetters } from 'vuex'
  import SharedProductProvide from '@/components/marketplace/shared/provide/Product'
  import FormGroup from '@/components/template/FormGroup'
  import Multiselect from 'vue-multiselect'
  import Loader from '@/components/template/Loader'
  import utils from 'utiljs-strings'
  import { AllHtmlEntities } from 'html-entities'

  export default {
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'madeira'
      },
      maxDescriptionLengthDI: 65535,
      allowDescriptionHtml: true
    },
    data: () => ({
      loadingAttributes: false,
      loadingCategories: false,
      categories: [],
      category: null,
      attributes: []
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.attributes = []

      this.loadingCategories = true
      api.getCategories('marketplace', 'madeira')
        .then(categories => { this.categories = categories })
        .catch(() => { this.categories = [] })
        .finally(() => { this.loadingCategories = false })

      this.product.category = ''

      const presetCategorization = this.$parent.getPresetItemsCategorization(this.product.categories)
      if (presetCategorization !== null && presetCategorization !== undefined) {
        this.category = this.categories.find(category => category.value === presetCategorization.categories)
      }

      if (this.product.warranty) {
        this.product.warranty = utils.stripTags(AllHtmlEntities.decode(this.product.warranty), '')
      } else if (this.product.warrantyTime) {
        this.product.warranty = `${this.product.warrantyTime} meses`
      }
      this.$parent.loadingProducts(false)
    },
    methods: {
      ...mapActions('errors', [
        'addError',
        'clearErrors'
      ]),
      formatProduct () {
        this.clearErrors()

        if (this.product.warranty === null || this.product.warranty === undefined || this.product.warranty === '') {
          this.addError({
            productId: this.product.productId,
            sku: this.product.productId,
            property: 'warranty',
            error: {
              message: 'required',
              value: 1
            }
          })
        }

        return this.product.variations
          .filter(variation => variation.selected)
          .map(variation => ({
            attributes: this.getAttributes(),
            brand: this.product.brand,
            color: this.getColor(variation),
            description: this.product.description,
            ean: variation.ean,
            grid: this.getGrid(variation),
            gridType: this.getType(variation),
            height: variation.height,
            images: variation.images.length ? variation.images : null,
            integrationCode: this.product.productId,
            length: variation.length,
            original: {
              product: this.product,
              variation: variation
            },
            price: variation.price,
            sku: variation.sku,
            source: this.fromModule,
            stock: variation.stock,
            title: this.product.title,
            weight: variation.weight,
            width: variation.width,
            categoryId: this.product.category
          })
        )
      },
      getType (variation) {
        if (variation.attributes['flavor']) {
          return 'flavor'
        }

        if (variation.attributes['voltage']) {
          return 'voltage'
        }

        return 'size'
      },
      getGrid (variation) {
        if (variation.attributes['flavor']) {
          return variation.attributes['flavor']
        }

        if (variation.attributes['voltage']) {
          return variation.attributes['voltage']
        }

        if (variation.attributes['size']) {
          return variation.attributes['size']
        }

        return 'Único'
      },
      getColor (variation) {
        if (variation.attributes.color !== undefined && variation.attributes.color !== null && !isEmpty(variation.attributes.color)) {
          return variation.attributes.color
        }

        return 'Única'
      },
      getAttributes () {
        const attributes = this.attributes
          .filter(attribute => {
            if (isArray(attribute.value)) {
              return attribute.value.length
            }

            return attribute.value !== undefined && attribute.value.trim() !== ''
          })
          .map(attribute => {
            return {
              id: attribute.label,
              label: attribute.label,
              valueId: attribute.value !== undefined && !isArray(attribute.value) ? [attribute.value].join(', ') : attribute.value.join(', '),
              valueLabel: attribute.value !== undefined && !isArray(attribute.value) ? [attribute.value].join(', ') : attribute.value.join(', ')
            }
          })

        if (this.product.warranty) {
          attributes.push({
            id: 'Garantia do fornecedor',
            label: 'Garantia do fornecedor',
            valueId: this.product.warranty,
            valueLabel: this.product.warranty
          })
        }

        return attributes
      },
      disabledInputs () {
        return this.product.status === 'sent' || this.product.status === 'error'
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ])
    },
    watch: {
      category (value) {
        this.product.category = value.code

        this.loadingAttributes = true
        api.getAttributes('madeira', { categories: this.product.category })
          .then(({ items }) => { this.attributes = items })
          .catch(() => {})
          .finally(() => { this.loadingAttributes = false })
      }
    },
    components: {
      SharedProductProvide,
      FormGroup,
      Multiselect,
      Loader
    }
  }
</script>



// WEBPACK FOOTER //
// Product.vue?367a5544